
export const primaryColor = '#72ca7e';
export const primaryDarkerColor = '#52a15d';

export const secondaryColor = '#c7c7c7';
export const secondaryDarkColor = '#b1b1b1';

export const backgroundColor = '#101012';
export const onBackgroundColor = '#ddd';
